import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const WalletIcon = (props: SvgIconProps) => <AccountBalanceWalletIcon {...props} />;
export default WalletIcon;
